import React from 'react'
import { useSelector } from 'react-redux'
import { Link, useLocation, useParams, useSearchParams} from "react-router-dom";
import { FormattedMessage, useIntl  } from 'react-intl';

import { Tabs } from 'antd';

import { COMPUTERS_GROUPS_PATH } from '../utils/constants';
import BreadcrumbHeader from './BreadcrumbHeader';
import ReportsFilter from './ReportsFilter';
import DetailedReport from './DetailedReport';
import {getPrinterDetailedColumns} from './GetDetailedColumns';
import ComputersGroupReportGeneral from './ComputerGroupReportGeneral';

const ComputersGroupReport = (props) => {

    let params = useParams();
    const groupId = parseInt(params['id'], 10);

    const location = useLocation();
    const intl = useIntl();

    const [searchParams] = useSearchParams();
    const serverId = searchParams.get("serverId")

    let filterData = useSelector(state => state.reportFilter);
    let groups = useSelector(state => state.compgroupsCache);
    let servers = useSelector(state => state.serversCache);
    
    if (!groupId)
    {
        return(
            <div><h3>Bad group Id</h3></div>
        );
    }

    let groupName = groups[groupId] ? groups[groupId] : "Group id = " + groupId;
    let serverName = (serverId && servers[serverId]) ? servers[serverId] : null

return (
        <div>
            <div className = "filter-report-picker">
                <ReportsFilter/>
            </div>
            <BreadcrumbHeader
                location = {location}
                objectLink = {groupName}
                server = {serverName}
                rootPath = {COMPUTERS_GROUPS_PATH}
                pathName = "ComputersGroup"
            />
            <br/>
                <Tabs defaultActiveKey="1" type="card">
                    <Tabs.TabPane tab={intl.formatMessage({ id: "LeftMenu.Submenu.general" })} key="1">
                        <ComputersGroupReportGeneral groupId = {groupId} filterData = {filterData}/>
                    </Tabs.TabPane>
                    <Tabs.TabPane tab={intl.formatMessage({ id: "Detailed" })} key="2">
                    <DetailedReport 
                            api_url = {"/job?comp_groupId=" + groupId} 
                            columns = {getPrinterDetailedColumns()}
                            filterData = {filterData}
                        />
                    </Tabs.TabPane>
                </Tabs>
                <Link to={COMPUTERS_GROUPS_PATH}><FormattedMessage id="Back"/></Link>
        </div>);
}

export default ComputersGroupReport;